import { useEffect, useRef, useCallback } from 'react';

export function usePolling(fn, interval = 10000, immediate = true) {
  const fnRef = useRef(fn);
  const timerRef = useRef(null);

  useEffect(() => { fnRef.current = fn; }, [fn]);

  const start = useCallback(() => {
    if (timerRef.current) return;
    timerRef.current = setInterval(() => fnRef.current(), interval);
  }, [interval]);

  const stop = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (immediate) fnRef.current();
    start();
    const onVisible = () => document.hidden ? stop() : (fnRef.current(), start());
    document.addEventListener('visibilitychange', onVisible);
    return () => { stop(); document.removeEventListener('visibilitychange', onVisible); };
  }, [start, stop, immediate]);
}